<template>
  <div class="sidebar-position-detail-index-polygon">
    <div
      class="sidebar-position-detail-index-polygon__top"
      :style="{
        'background-color': activePosition.gemeente.app_asset
          ? activePosition.gemeente.app_asset.color_primary
          : null
      }"
    >
      <div class="sidebar-position-detail-index-polygon__top__left">
        <svg svg-inline="" @click="closeSidebarPositionDetailIndexPolygon" class="sidebar-position-detail-index-polygon__top__left__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" d="M16 4.462L14.603 3 6 12l8.603 9L16 19.538 8.795 12z"/></g></svg>
        <div class="sidebar-position-detail-index-polygon__top__left__text">
          Gebiedsmeldingen
        </div>
      </div>
    </div>

    <div class="sidebar-position-detail-index-polygon__list-bottom">
      <SidebarListItem
        v-for="feature in polygonFeatures"
        :key="feature.id"
        @click.native="setActiveFeature(feature)"
        :active="
          activeFeature
            ? activeFeature.properties.id == feature.properties.id
            : false
        "
      >
        <div class="sidebar-list-item__left">
          <img
            :src="imageUrl(feature.properties.category_id)"
            class="sidebar-list-item__left__icon"
          />
        </div>
        <div class="sidebar-list-item__middle">
          <div
            :class="{
              'sidebar-list-item__middle__text-title': true,
              read: isRead(feature.properties.id)
            }"
          >
            {{ feature.properties.name }}
          </div>
          <div class="sidebar-list-item__middle__text-subtitle">
            {{ $dayjs(feature.properties.published_at).format("LL") }} -
            {{ getCategoryName(feature.properties.category_id) }}
          </div>
          <div class="sidebar-list-item__middle__text-subtitle">
            {{ feature.properties.distance }}m
          </div>
        </div>
        <div class="sidebar-list-item__right">
          <svg svg-inline="" class="sidebar-list-item__right__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-180 13 12)" d="M18 4.462L16.603 3 8 12l8.603 9L18 19.538 10.795 12z"/></g></svg>
        </div>
      </SidebarListItem>
    </div>
  </div>
</template>

<script>
import LoadOrReturnCategories from "@/services/LoadOrReturnCategories.js";
import SidebarListItem from "@/components/SidebarListItem";
import CategoryIdToString from "@/services/CategoryIdToString";

export default {
  components: {
    SidebarListItem
  },
  data() {
    return {
      // pointFeatures: null,
      // polygonFeaturesLength: 0,
      loadedCategories: null
    };
  },
  mounted() {
    let self = this;

    LoadOrReturnCategories().then(function(categories) {
      self.loadedCategories = categories;
    });
  },
  computed: {
    activeFeature() {
      return this.$store.state.ui.activeFeature;
    },
    activePosition() {
      return this.$store.state.ui.activePosition;
    },
    polygonFeatures() {
      return this.$store.state.ui.polygonFeatures;
    },
    readFeatures() {
      return this.$store.state.ui.readFeatures;
    }
  },
  methods: {
    closeSidebarPositionDetailIndexPolygon() {
      this.$store.commit("setActiveFeature", null);
      this.$store.commit("closeSidebarPositionDetailIndexPolygon");
      this.$store.commit("openSidebarPositionDetailIndex");
    },
    setActiveFeature(feature) {
      this.$store.commit("setActiveFeature", feature);
      this.$store.commit("setReadFeatures", feature);
    },
    imageUrl(categoryId) {
      if (this.loadedCategories) {
        return this.loadedCategories.data.find(x => x.id == categoryId)
          .icon_url;
      }
    },
    isRead(featureId) {
      return this.readFeatures.includes(featureId);
    },
    getCategoryName(category_id) {
      let string = CategoryIdToString(category_id);
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
};
</script>

<style scoped lang="scss">
.sidebar-position-detail-index-polygon {
  position: fixed;
  width: 100%;
  max-width: 414px;
  background: $color-gray-2;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 3000;
  box-shadow: 2px 4px 10px 0 rgba(0, 0, 0, 0.05);

  &__top {
    height: 52px;
    display: flex;
    align-items: center;
    padding-left: $spacing-3;
    background: $color-green-1;

    &__left {
      display: flex;
      align-items: center;

      &__icon {
        display: inline-block;
        position: relative;
        top: 1px;
        cursor: pointer;

        path {
          fill: #fff;
        }
      }
      &__text {
        display: inline-block;
        @extend %text-large;
        color: #fff;
        padding: 0 $spacing-2;
      }
    }
  }

  &__flash {
    padding: $spacing-3;

    &__title {
      @extend %text-small;
    }
  }

  &__list-bottom {
    overflow-y: auto;
    flex: 1;
  }
}
</style>
